import FindContractors from "../modules/find-contractors";
import MoreLinks from "../modules/more-links";

class Archive {

    constructor(root) {
        this.container = root;
        this.moreLinksContainer = this.container.querySelector('.more-links');

        this.findContractors = [];

        this.container.querySelectorAll('.find-contractors .search-container').forEach(n => this.initLocationSearch(n, this));

        if(this.moreLinksContainer) {
            this.moreLinks = new MoreLinks(this.moreLinksContainer);
        }
    }

    initLocationSearch(node, instance) {
        instance.findContractors.push(new FindContractors(node));
    }
}

export { Archive }